/* eslint-disable prettier/prettier */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable import/order */
import { FC } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Span } from 'libs/common-components/src';
import dayjs from 'dayjs';
import { IOrderData } from '@bvi/api-interfaces/response/manage-base-data';
import { OrderActionMenu } from '@bvi/admin-panel/feature/orders/ui/order-action-menu';
import { styles } from '@bvi/admin-panel/feature/manage-list/ui/manage-base-table/manage-base-row/styles';

interface IOrderTableRowProperties {
  order: IOrderData;
}

export const OrderTableRow: FC<IOrderTableRowProperties> = ({
  order,
  ...properties
}) => {
  const dateFormatted = dayjs(order.createdAt).format('MM/DD/YYYY');

  return (
    <TableRow {...properties}>
      <TableCell>
        <Span sx={styles.tooltipContent}>{order.id}</Span>
      </TableCell>
      <TableCell>
        <Span sx={styles.tooltipContent}>{order.name}</Span>
      </TableCell>
      <TableCell>
        <Span sx={styles.tooltipContent}>{dateFormatted}</Span>
      </TableCell>
      <TableCell>
        <OrderActionMenu
          id={order.id}
          detail={order}
        />
      </TableCell>
    </TableRow>
  );
};

